export const ModuleContext = 'context';
export const ModuleOption = 'option';
export const ModuleEmployee = 'employee';
export const ModuleBudgetPlan = 'budgetPlan';
export const ModuleEReceipt = 'eReceipt';
export const ModuleEReceiptSummary = 'eReceiptSummary';
export const ModuleUserManagement = 'userManagement';
export const ModuleAdvancedSercurity = 'advancedSercurity';
export const ModuleRole = 'role';

//#region Dự toán ngân sách
//#region Quy trình
export const ModuleReportTemplateLibrary = 'reportTemplateLibrary';
//#endregion
//#endregion

export const ModuleCACash = 'caCash';
export const ModuleCACashReceipt = 'caCashReceipt';
export const ModuleCACashWithdraw = 'caCashWithdraw';
export const ModuleCACashPayment = 'caCashPayment';
export const ModuleCAFundInventory = 'caFundInventory';
export const ModuleBUCreateDeclareTable = 'caCash';
export const ModuleBudgetKindItem = 'budgetKindItem';
export const ModuleBudgetSourceProperty = 'budgetSourceProperty';
export const ModuleAccountTransfer = 'diAccountTransfer';
export const ModuleAccount = 'account';
export const ModuleBADeposit = 'baDeposit';
export const ModuleBAWithdraw = 'baWithdraw';
export const ModuleBAInternalTransfer = 'baInternalTransfer';
export const ModuleBAAdvanceNSNN = 'baAdvanceNSNN';
export const ModuleBudgetChapter = 'diBudgetChapter';
export const ModuleBudgetChapterGrade = 'diBudgetChapterGrade';
export const ModuleDiCacheConfig = 'diCacheConfig';
export const ModuleBUCommitmentRequest = 'buCommitmentRequest';
export const ModuleBUReceiptExpense = 'buReceiptExpense';
export const ModuleBudgetPlanAdjustment = 'budgetPlanAdjustment';
export const ModuleDVCFile = 'dvcFile';
export const ModuleDVCCashWithDrawVoucher = 'dvcCashWithDrawVoucher';
export const ModuleDVCAdvancePayment = 'dvcAdvancePayment';
export const ModuleDVCInvestmentAdvance = 'dvcInvestmentAdvance';
export const ModuleSalaryScale = 'salaryScale';
export const ModuleStock = 'diStock';
export const ModuleBankInfoCategory = 'diBankInfoCategory';
export const ModuleFixedAssetCategory = 'diFixedAssetCategory';
export const ModuleAccountParallelRule = 'diAccountParallelRule';
export const ModuleAccountChangeTranfer = 'accountChangeTranfer';
export const ModuleBankInfo = 'diBankInfo';
export const ModuleAutoBusiness = 'diAutoBusiness';
export const ModuleBudgetItemDetail = 'diBudgetItemDetail';
export const ModuleBudgetProvide = 'diBudgetProvide';
export const ModuleBudgetDistribution = 'diBudgetDistribution';
export const ModuleDefaultAccount = 'diDefaultAccount';
export const ModuleBudgetGroupItem = 'diBudgetGroupItem';
export const ModuleInventoryCategory = 'inventoryCategory';
export const ModuleInventoryItem = 'inventoryItem';
export const ModuleEquipmentInventoryItem = 'diEquipmentInventoryItem';
export const ModuleToolList = 'toolList';
export const ModuleProject = 'project';
export const ModuleAccountingObjectCategory = 'diAccountingObjectCategory';
export const ModuleBudgetItem = 'diBudgetItem';
export const ModuleBudgetSource = 'diBudgetSource';
export const ModuleEmployeeIncomeTax = 'employeeIncomeTax';
export const ModuleFund = 'diFund';
export const ModuleFixedAsset = 'fixedAsset';
export const ModuleFixedAssetCustom = 'fixedAssetCustom';
export const ModuleFixedAssetDepreciation = 'fixedAssetDepreciation';
export const ModuleUpdateAccountCopyVoucherPopup = 'updateAccountCopyVoucherPopup';
export const ModuleUtilityCopyVoucherPopup = 'utilityCopyVoucherPopup';
export const ModuleQltsVoucher = 'faVoucher';
export const ModuleDepartment = 'diDepartment';
export const ModuleDIFixedAsset = 'diFixedAsset';
export const ModuleAccountingObject = 'diAccountingObject';
export const ModuleAccountingObject01 = 'diAccountingObject01';
export const ModuleAccountingObjectList = 'diAccountingObjectList';
export const ModuleActivity = 'diActivity';
export const ModuleCommercialBank = 'diCommercialBank';
export const ModuleBudgetSourceDvc = 'diBudgetSourceDvc';
export const ModuleActivityCategory = 'diActivityCategory';
export const ModuleHamlet = 'diHamlet';
export const ModuleBranch = 'diBranch';
export const ModuleStatistic = 'diStatistic';
export const ModulePlanActivityTemplateBySymmetrical = 'diPlanActivityTempSymmet'; // module báo cáo phân chi cân đối
export const ModuleFundStructure = 'diFundStructure'; // Module danh mục nội dung chi phí
export const ModuleContract = 'diContract'; // Module danh mục Hợp đồng
export const ModuleBuPlanReceiptReport = 'diBudgetChapter'; // module báo cáo phân chi cân đối
export const ModulePAOption = 'paOption'; // Module danh mục Lương => biểu tính thuế thu nhập (Quy định lương, thuế, bảo hiểm)
export const ModuleGeneralVoucher = 'gLVoucher';
export const ModuleVoucherList = 'gLVoucherList';
export const ModuleVoucherListDetail = 'gLVoucherListDetail';
export const ModuleRegisterList = 'gLRegisterList';
export const ModuleRegisterDetail = 'gLRegisterDetail';
export const ModuleINTransfer = 'inTransfer';
export const ModuleLocalBudgetItem = 'diLocalBudgetItem'; // module danh mục Khoản chi xã
export const ModuleSUTransfer = 'sUTransfer';
export const ModuleSUDecrement = 'sUDecrement';
export const ModuleBuPlanReceipt = 'buPlanReceipt';
export const ModuleBuFinancialActivities = 'buFinancialActivities'; // Kế hoạch hoạt động tài chính khác
export const ModuleSUIncrement = 'sUIncrement';
export const ModuleINInward = 'inInward';
export const ModuleINOutward = 'inOutward';
export const ModuleCAExpenseAdjustment = 'caExpenseAdjustment';
export const ModuleCAReceiptAdjustment = 'caReceiptAdjustment';
export const ModulePlanActivityTemp = 'planActivityTemp';
export const ModuleSUSubmitReport = 'suSubmitReport'; // Nộp báo cáo lên cấp trên
export const ModuleBackup = 'backup';
export const ModuleDataManagement = 'dataManagement';
export const ModuleDataManagementList = 'dataManagementList';
export const ModuleCreateReport = 'cRVoucher';
export const ModuleCreateReportTemplate = 'frTemplateCustom';
export const ModuleDefaultImplicitSetting = 'defaultImplicitSetting';
export const ModuleAccessHistory = 'diAccessHistory';
export const ModuleRegimePosted = 'diRegimePosted';
export const ModuleInitialAccountBalance = 'initialAccountBalance'; // Module nhập số dư ban đầu
export const ModuleBankAccountBalance = 'bankAccountBalance'; // Module số dư tài khoản ngân hàng
export const ModuleAccountingObjectBalance = 'accountingObjectBalance'; // Module số dư theo đối tượng
export const ModuleAccountBalanceDetail = 'accountBalanceDetail'; // Module số dư theo đối tượng
export const ModuleInventoryMaterial = 'inventoryMaterial'; // Module tồn kho vật tư
export const ModuleAnotherAccountBalance = 'anotherAccountBalance'; // Module số dư tài khoản khác
export const ModuleOpeningAccountEntry = 'openingAccountEntry'; // Module số dư tài khoản khác
export const ModuleReportUpdateHistory = 'diReportUpdateHistory';
//#region Lương
export const ModuleSalaryVoucher = 'salaryVoucher';
export const ModuleVoucherFromSalagov = 'voucherFromSalagov';
export const ModulewithdrawFromSalagov = 'withdrawFromSalagov';
//#endregion
export const ModuleChooseFinanceReportSetting = 'chooseFinanceReportSetting';
export const ModuleBUPlanAdjustCommit = 'BUPlanAdjustCommit'; // pntoan 11.5.2023 PBI 3060 Module Điều chỉnh cam kết chi
export const ModuleColumnList = 'columnList';
export const ModuleFrTemplateCustom = 'frTemplateCustom';
export const ModuleFormulaCustom = 'formulaCustom';
export const ModuleCellReportSetting = 'cellReportSetting'; // Thiết lập công thức
export const ModuleBUBudgetReserve = 'buBudgetReserve';
export const ModuleFunctionList = 'frFunctionList';

export const ModuleImportExcel = 'importExcel';
export const ModuleImportStepFirst = 'importStepFirst';
export const ModuleBuPlanWdAdjustment = 'buPlanWdAdjustment'; //  Module Dự toán ngân sách/ Điều chỉnh kinh phí

export const ModuleBuTransfer = 'buTransfer';
export const ModuleConstructionBudget = 'constructionBudget';

export const ModuleSortRefNo = 'sortRefNo'; // Module sắp xếp lại chứng từ
export const ModuleBuPlanActivityBudgetList = 'buPlanActivityBudgetList';
export const ModuleBuPlanActivityTempCircular = 'buPlanActivityTempCircular'; //Module thiết lập báo cáo dạng 1 bảng
export const ModuleBuPlanSummary = 'buPlanSummary';
export const ModuleHideShowColumn = 'hideShowColumn';
export const ModuleNotification = 'notification';

export const ModuleStaticReportPrint = 'staticReportPrint';

// báo cáo nhanh
export const ModuleQuickReport = 'quickReport';

export const ModuleReportCustom = 'reportCustom';
export const ModulePostBatch = 'postBatch';
export const ModulePostMulti = 'postMulti'; // module ghi sổ nhiều chứng từ

// so sánh đối chiếu chỉ tiêu 07 vs 08, 09
export const ModuleActivityCompared = 'activityCompared';

//  Lịch sử filter
export const ModuleFilterHistory = 'diFilterHistory';

// Hoá đơn inbot
export const ModuleInbotInvoice = 'inbotInvoice';

// Hoá đơn inbot
export const ModuleSupplierInvoiceBot = 'supplierInvoiceBot';
export const ModuleReportSortInfo = 'reportSortInfo';
export const ModuleOrderPopupStore = 'orderPopup';
export const ModuleDvcBudget = 'dvcBudget';

// Tổng quan
export const ModuleDashboardParam = 'dashboardParam';
export const ModuleDashboardData = 'dashboardData';
export const ModuleDcsdFile = 'dcsdFile';

// AVA Plafform
export const ModuleAVACheckSpell = 'moduleAVACheckSpell';

export const ModuleVoucherInformationArise = 'diVoucherInformationArise';

export const ModuleDbOption = 'diDbOption';

export const ModuleExpenseNormRegulation = 'expenseNormRegulation';

export const ModuleExpenseNormRegulationTest = 'expenseNormRegulationTest';
export const ModuleCheckExpenseNormRegulationTestResult = 'checkExpenseNormRegulationTestResult';

export const ModuleVoucherNoGenParralel = 'voucherNoGenParralel';

export const ModuleDvcVoucherNotGenerate = 'dvcVoucherNotGenerate';

export const ModuleBussinessTour = 'bussinessTour';
export const ModuleSearchVoucher = 'searchVoucher';

export const ModuleVoucherDeleted = "voucherDeleted";

/**
 * Danh sách module của chương trình
 */
export const AppModules = [
  ModuleSupplierInvoiceBot,
  ModuleEmployee,
  ModuleContext,
  ModuleEmployee,
  ModuleBudgetPlan,
  ModuleBUCreateDeclareTable,
  ModuleBudgetKindItem,
  ModuleBudgetSourceProperty,
  ModuleAccount,
  ModuleBADeposit,
  ModuleBAWithdraw,
  ModuleBAInternalTransfer,
  ModuleBudgetChapter,
  ModuleBudgetChapterGrade,
  ModuleAccountChangeTranfer,
  ModuleSalaryScale,
  ModuleStock,
  ModuleBankInfoCategory,
  ModuleDiCacheConfig,
  ModuleAccountParallelRule,
  ModuleDVCFile,
  ModuleDVCCashWithDrawVoucher,
  ModuleDVCAdvancePayment,
  ModuleDVCInvestmentAdvance,
  ModuleBUCommitmentRequest,
  ModuleBankInfo,
  ModuleAccountTransfer,
  ModuleAutoBusiness,
  ModuleBudgetItemDetail,
  ModuleBudgetProvide,
  ModuleDefaultAccount,
  ModuleBudgetGroupItem,
  ModuleInventoryCategory,
  ModuleInventoryItem,
  ModuleEquipmentInventoryItem,
  ModuleToolList,
  ModuleProject,
  ModuleBudgetSource,
  ModuleBudgetItem,
  ModuleAccountingObjectCategory,
  ModuleEmployeeIncomeTax,
  ModuleFund,
  ModuleDIFixedAsset,
  ModuleFixedAsset,
  ModuleQltsVoucher,
  ModuleDepartment,
  ModuleAccountingObject,
  ModuleAccountingObjectList,
  ModuleActivity,
  ModuleCommercialBank,
  ModuleBudgetSourceDvc,
  ModuleActivityCategory,
  ModuleHamlet,
  ModuleBranch,
  ModuleStatistic,
  ModuleFundStructure,
  ModuleContract,
  ModulePAOption,
  ModuleGeneralVoucher,
  ModuleINTransfer,
  ModuleLocalBudgetItem,
  ModuleSUTransfer,
  ModuleSUDecrement,
  ModuleSUIncrement,
  ModuleINInward,
  ModuleBuPlanReceipt,
  ModuleCAExpenseAdjustment,
  ModuleCAReceiptAdjustment,
  ModuleUserManagement,
  ModuleAdvancedSercurity,
  ModuleSUSubmitReport,
  ModuleINOutward,
  ModuleBackup,
  ModuleCreateReport,
  ModuleCreateReportTemplate,
  ModuleAccessHistory,
  ModuleDefaultImplicitSetting,
  ModuleRegimePosted,
  ModuleInitialAccountBalance,
  ModuleBankAccountBalance,
  ModuleEReceipt,
  ModuleEReceiptSummary,
  ModuleReportUpdateHistory,
  ModulePlanActivityTemp,
  ModuleSalaryVoucher,
  ModuleChooseFinanceReportSetting,
  ModuleColumnList,
  ModuleFormulaCustom,
  ModuleFrTemplateCustom,
  ModuleCellReportSetting,
  ModuleImportExcel,
  ModuleImportStepFirst,
  ModuleBuPlanWdAdjustment,
  ModuleBUBudgetReserve,
  ModuleBuTransfer,
  ModuleBudgetDistribution,
  ModuleFunctionList,
  ModuleConstructionBudget,
  ModuleSortRefNo,
  ModuleBuPlanActivityBudgetList,
  ModuleOpeningAccountEntry,
  ModuleUpdateAccountCopyVoucherPopup,
  ModuleUtilityCopyVoucherPopup,
  ModuleHideShowColumn,
  ModuleStaticReportPrint,
  ModuleDataManagement,
  ModuleDataManagementList,
  ModuleQuickReport,
  ModuleNotification,
  ModuleReportCustom,
  ModulePostBatch,
  ModulePostMulti,
  ModuleActivityCompared,
  ModuleFilterHistory,
  ModuleBuPlanActivityTempCircular,
  ModuleInbotInvoice,
  ModuleOrderPopupStore,
  ModuleReportSortInfo,
  ModuleOrderPopupStore,
  ModuleDvcBudget,
  ModuleBAAdvanceNSNN,
  ModuleDashboardParam,
  ModuleDashboardData,
  ModuleDcsdFile,
  ModuleVoucherInformationArise,
  ModuleReportTemplateLibrary,
  ModuleDbOption,
  ModuleExpenseNormRegulation,
  ModuleExpenseNormRegulationTest,
  ModuleVoucherNoGenParralel,
  ModuleDvcVoucherNotGenerate,
  ModuleBussinessTour,
  ModuleSearchVoucher,
  ModuleVoucherDeleted,
];
